var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"24px"}},[_c('triz-validator',{attrs:{"rules":"required","id":"项目概述"}},[_c('Tinymce',{attrs:{"placeholder":"请输入项目概述"},on:{"input":_vm.change},model:{value:(_vm.triz.projectDescription),callback:function ($$v) {_vm.$set(_vm.triz, "projectDescription", $$v)},expression:"triz.projectDescription"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }